import api from './../../Api.js';

function Unit_helper(props){
		
	this.props = props; 
	//console.log('executou helper');

}

 

Unit_helper.prototype.getUnitsCourse = async function(course){

	//for (var i = 0; i < this.props.units.length; i++) {//}
	var req = await api.getUnitsCourse(course).then(async (res) => {
    	
    	return {status:200,data:res.data};
      //await this.setState({units:res.data});

     //if(res.data[0] !== undefined){

        //this.changeUnit(res.data[0].id);

      //}

    }).catch(error => {

      if(error.response.status === 400){

      	return {status:400,data:error.response};

      }

      return false;

    });

	return req;

}



export default Unit_helper;